import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type VerifyTokenRequest = {
  recoveryToken: string;
};
export const verifyTokenRequest = async (requestBody: VerifyTokenRequest) => {
  try {
    const result = await post('/guest/verifyToken', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
